import * as React from 'react';
import './MatrixTable.scss';
import MatrixCell from './Components/MatrixCell'

import MatrixView from '../MatrixView';
import { WorkflowsJourney } from '../../../../Models/Quests/Quests.Model';
import { MatrixCellInterface, MatrixQuestInterface } from '@swivl-mono/types';

// const data = [
//   [{type:"spacer"}, {type:"value", variable:"c", axis:"x", values:["NOT_SET"]}, {type:"value", variable:"c",  axis:"x", values:["black", "navy"]}, {type:"value", variable:"c",axis:"x", values:["green"]}  ],
//   [{type:"value", variable:"s", axis:"y", values:["small"]}, {type:"quest", quest:"abcdefg"}, {type:"quest", quest:"abcdefg"}, {type:"quest", quest:"abcdefg"}  ],
//   [{type:"value", variable:"s", axis:"y", values:["medium", "large"]}, {type:"quest", quest:"abcdefg"}, {type:"quest", quest:"abcdefg"}, {type:"quest", quest:"abcdefg"}  ],
// ]
interface Props {
  data: MatrixCellInterface[][],

  delegate: MatrixView,
  workflows: WorkflowsJourney[],
  matrix: MatrixQuestInterface
  canEdit: boolean
}
interface State {
  focus: {x:any, y:any},
  showMenu: {x?:number, y?:number, side?:string}
}


export default class MatrixTable extends React.Component<Props,State> {
  constructor(props) {
    super(props)
    this.state = {focus:{x:0, y:0},  showMenu:{x:undefined, y:undefined}}
    // this.keydownHandler = this.keydownHandler.bind(this)
    this.setFocus       = this.setFocus.bind(this)
    this.setShowMenu    = this.setShowMenu.bind(this)
    this.renderRow      = this.renderRow.bind(this)
    this.renderCell     = this.renderCell.bind(this)


  }
  // componentDidMount() {
  //   $(document).keydown(this.keydownHandler);
  // }
  // componentWillUnmount() {
  //   $(document).unbind('keydown', this.keydownHandler);
  // }

  // keydownHandler(event) {

  //   const key = event.which;
  //   let focus = {x:this.state.focus.x, y:this.state.focus.y};


  //   if (isNaN(parseInt(focus.x)) || isNaN(parseInt(focus.y))) {
  //       this.setFocus(0, 0);


  //       return;
  //   }
  //   if (this.state.showMenu.x === focus.x &&
  //       this.state.showMenu.y === focus.y
  //     )  {
  //       //"Prevent! We are in a menu.");
  //       return;
  //   }

  //   if (key >= 37 && key <= 40 && !isNaN(parseInt(focus.x)) && !isNaN(parseInt(focus.y))) {

  //     if (key === 37) { focus.x--; }
  //     if (key === 38) { focus.y--; }
  //     if (key === 39) { focus.x++; }
  //     if (key === 40) { focus.y++; }
  //     if (
  //       focus.x >= this.props.data[0].length - 1 ||
  //       focus.x < 0 ||
  //       focus.y >= this.props.data.length - 1 ||
  //       focus.y < 0
  //     ) {
  //         //"Out of bounds", focus);
  //       if (this.props.data[focus.y] && this.props.data[focus.y][focus.x] &&  this.props.data[focus.y][focus.x].type && this.props.data[focus.y][focus.x].type === "add") {
  //         this.setFocus(focus.x, focus.y);
  //         return;
  //       }

  //       return;
  //     }

  //     this.setFocus(focus.x, focus.y);
  //     return;

  //   }
  //   if (key === 27) { // Escape key
  //     this.setShowMenu(null, null);
  //     return;
  //   }
  //   if (key === 13) { // Return Key
  //     if (this.props.data[focus.y] && this.props.data[focus.y][focus.x] &&  this.props.data[focus.y][focus.x].type && this.props.data[focus.y][focus.x].type === "add") {
  //       this.props.delegate.addColumnOrRow(this.props.data[focus.y][focus.x].direction);
  //       return;
  //     }

  //     if (this.state.showMenu.x === focus.x && this.state.showMenu.y === focus.y)  {
  //       this.setShowMenu(null, null);
  //     } else {
  //       this.setShowMenu(focus.x, focus.y);
  //     }
  //   }
  // }

  setFocus(x,y) {
    this.setState({focus:{x:x, y:y}, showMenu:{x:undefined, y:undefined}});
  }
  setShowMenu(x?,y?, keepFocus?, side?) { // side is optional and just for spacer variable labels


    if (keepFocus) { this.setState({showMenu:{x:x, y:y, side:side}});  return; }
    this.setState({showMenu:{x:x, y:y, side:side}, focus:{x:x, y:y}});
   }
  renderRow(item,index) {
    const cols = item.map((colItem,colIndex) => this.renderCell(colItem,colIndex, index));

    return <tr key={"row_"+index}>
      {cols}
    </tr>
  }
  renderCell(item, index, rowIndex) {
    // if (item.type ===  "value") {
    //   return  <td key={"cell_"+rowIndex +"_"+index}><MatrixValueCell item={item} ></MatrixValueCell>
    // }

    return <MatrixCell
              key={"cell_"+rowIndex +"_"+index}
              item={item}
              x={index}
              y={rowIndex}
              focus={this.state.focus}

              showMenu={this.state.showMenu}
              setFocus={this.setFocus}
              setShowMenu={this.setShowMenu}



              delegate={this.props.delegate}
              workflows={this.props.workflows}
              matrix={this.props.matrix}
              canEdit={this.props.canEdit}

              />
  }



  render() {
      const  rows = this.props.data.map((item, index) => this.renderRow(item,index) )

        return <table className="MatrixTable">
          <tbody>
            {rows}
          </tbody>
        </table>
  }

};
